import React from "react";
import { Icon, D } from "./icons";

const MAP = "m3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2z M9 3v16 M15 5v16";
const LIST = "M7 6h15 M7 12h15 M7 18h15 M2 6h1 M2 12h1 M2 18h1";
export const VIEW_ICONS = { map: MAP, list: LIST };

/**
 * `.filter-tabs` of iTruck_Search_Unified (saved searches are out by decision). The extra fields open only from
 * «Дополнительные параметры» in the form footer, so there is no «Дополнительные фильтры» tab.
 */
export function FilterTabs({ onParams, onMap, onList, view }) {
  return (
    <div className="filter-tabs">
      <button type="button" className="active" data-action="parameters" onClick={onParams}>
        <Icon d={D.search} />
        Параметры поиска
      </button>
      <button type="button" data-action="map" className={view === "map" ? "on" : ""} onClick={onMap}>
        <Icon d={MAP} />
        На карте
      </button>
      <button type="button" data-action="list" className={view === "list" ? "on" : ""} onClick={onList}>
        <Icon d={LIST} />
        Списком
      </button>
    </div>
  );
}

/** `.search-footer`: «Сбросить» + primary submit. */
export function SearchFooter({ onReset, submit }) {
  return (
    <div className="search-footer">
      <div className="search-buttons">
        <button type="button" className="button reset" onClick={onReset}>
          Сбросить
        </button>
        <button type="submit" className="button primary search-submit">
          <Icon d={D.search} />
          {submit}
        </button>
      </div>
    </div>
  );
}
